/**
 * Range slider
 * @requires https://refreshless.com/nouislider/
 */

export default (() =>
{
  const rangeSliderWidgets = document.querySelectorAll('[data-range-slider]');

  if (rangeSliderWidgets.length === 0)
    return;

  // Check the dir attribute on html tag and set the default to "ltr" if it's not set or invalid
  const htmlElement = document.documentElement;
  const direction = htmlElement.getAttribute('dir') === 'ltr' || htmlElement.getAttribute('dir') === 'rtl'
    ? htmlElement.getAttribute('dir')
    : 'ltr';

  window.cartzilla = window.cartzilla || {};

  window.cartzilla.createRangeSliderWidget = function (rangeSliderWidget)
  {
    const rangeSlider = rangeSliderWidget.querySelector('.range-slider-ui');
    const valueMinInput = rangeSliderWidget.querySelector('[data-range-slider-min]');
    const valueMaxInput = rangeSliderWidget.querySelector('[data-range-slider-max]');

    let dataOptions;

    if (rangeSliderWidget.dataset.rangeSlider !== undefined)
      dataOptions = JSON.parse(rangeSliderWidget.dataset.rangeSlider);

    const options =
    {
      startMin: parseInt(dataOptions.startMin, 10),
      startMax: parseInt(dataOptions.startMax, 10),
      min: parseInt(dataOptions.min, 10),
      max: parseInt(dataOptions.max, 10),
      step: parseInt(dataOptions.step, 10),
      pips: dataOptions.pips,
      tooltipPrefix: dataOptions.tooltipPrefix || '',
      tooltipSuffix: dataOptions.tooltipSuffix || '',
    }

    const start = options.startMax
      ? [options.startMin, options.startMax]
      : [options.startMin];
    const connect = options.startMax ? true : 'lower';

    /* eslint-disable no-undef */
    noUiSlider.create(rangeSlider,
      {
        direction: direction,
        start: start,
        connect: connect,
        step: options.step,
        pips: options.pips ? { mode: 'count', values: 5 } : false,
        tooltips: true,
        range:
        {
          min: options.min,
          max: options.max,
        },
        format:
        {
          to: function (value)
          {
            return (
              options.tooltipPrefix + parseInt(value, 10) + options.tooltipSuffix
            );
          },
          from: function (value)
          {
            return Number(value);
          },
        },
      });

    window.cartzilla.mergeRangeSliderTooltips(rangeSlider, 15, ' - ');

    rangeSlider.noUiSlider.on('update', (values, handle) =>
    {
      let value = values[handle];
      value = value.replace(/\D/g, '');

      if (handle)
      {
        if (valueMaxInput)
          valueMaxInput.value = Math.round(value);
      }
      else
      {
        if (valueMinInput)
          valueMinInput.value = Math.round(value);
      }
    });

    if (valueMinInput)
    {
      valueMinInput.addEventListener('change', function ()
      {
        rangeSlider.noUiSlider.set([this.value, null]);
      });
    }

    if (valueMaxInput)
    {
      valueMaxInput.addEventListener('change', function ()
      {
        rangeSlider.noUiSlider.set([null, this.value]);
      });
    }
  }

  /**
    * @param rangeSlider HtmlElement with an initialized slider
    * @param threshold Minimum proximity (in percentages) to merge tooltips
    * @param separator String joining tooltips
  */
  window.cartzilla.mergeRangeSliderTooltips = function (rangeSlider, threshold, separator)
  {
    var textIsRtl = getComputedStyle(rangeSlider).direction === 'rtl';
    var isRtl = rangeSlider.noUiSlider.options.direction === 'rtl';
    var isVertical = rangeSlider.noUiSlider.options.orientation === 'vertical';
    var tooltips = rangeSlider.noUiSlider.getTooltips();
    var origins = rangeSlider.noUiSlider.getOrigins();

    // Move tooltips into the origin element. The default stylesheet handles this.
    for (var i = 0; i < origins.length; i++)
    {
      if (!tooltips[i])
        continue;

      origins[i].appendChild(tooltips[i]);
    }

    rangeSlider.noUiSlider.on('update', function (values, handle, unencoded, tap, positions)
    {
      // Normalize positions array to percentage (noUi can give 0..100 or 0..1000)
      var scale = 1;

      for (var k = 0; k < positions.length; k++)
      {
        if (positions[k] <= 100)
          continue;

        scale = 10;

        break;
      }

      var toPercent = function (p)
      {
        return p / scale;
      };

      var sliderSize = isVertical
        ? rangeSlider.clientHeight
        : rangeSlider.clientWidth;

      // Make all tooltips measurable
      for (var t = 0; t < tooltips.length; t++)
      {
        if (!tooltips[t])
          continue;

        tooltips[t].style.display = 'block';
        tooltips[t].style.whiteSpace = 'nowrap';
      }

      // Dynamic pooling based on overlap in pixels
      var pools = [[]];
      var poolPositions = [[]];
      var poolValues = [[]];
      var atPool = 0;

      // Helper to get tooltip size on the main axis
      var tipSize = function (idx)
      {
        var el = tooltips[idx];

        return isVertical
          ? el.offsetHeight
          : el.offsetWidth;
      };

      // Assign the first tooltip to the first pool, if the tooltip is configured
      if (tooltips[0])
      {
        pools[0][0] = 0;
        poolPositions[0][0] = positions[0];
        poolValues[0][0] = values[0];
      }

      for (var i = 1; i < positions.length; i++)
      {
        // If this handle has no tooltip, start a new pool
        if (!tooltips[i])
        {
          atPool++;
          pools[atPool] = [];
          poolValues[atPool] = [];
          poolPositions[atPool] = [];

          continue;
        }

        var prevIndex = pools[atPool].length ? pools[atPool][pools[atPool].length - 1] : null;

        // If the current pool is empty (previous handle had no tooltip), seed it
        if (prevIndex === null)
        {
          pools[atPool].push(i);
          poolValues[atPool].push(values[i]);
          poolPositions[atPool].push(positions[i]);

          continue;
        }

        // Distance between handles in percent
        var deltaPercent = toPercent(positions[i]) - toPercent(positions[prevIndex]);

        // Required separation to avoid overlap, derived from tooltip sizes
        var requiredPercent = ((tipSize(prevIndex) + tipSize(i)) / 2) / sliderSize * 100;

        // Effective threshold = max(user threshold, required size-based gap)
        var effectiveThreshold = Math.max(threshold, requiredPercent);

        if (deltaPercent > effectiveThreshold)
        {
          // Start a new pool
          atPool++;
          pools[atPool] = [i];
          poolValues[atPool] = [values[i]];
          poolPositions[atPool] = [positions[i]];
        }
        else
        {
          // Merge into current pool
          pools[atPool].push(i);
          poolValues[atPool].push(values[i]);
          poolPositions[atPool].push(positions[i]);
        }
      }

      pools.forEach(function (pool, poolIndex)
      {
        var handlesInPool = pool.length;

        for (var j = 0; j < handlesInPool; j++)
        {
          var handleNumber = pool[j];

          if (j !== handlesInPool - 1) // Hide this tooltip
          {
            tooltips[handleNumber].style.display = 'none';

            continue;
          }

          var offset = 0;

          poolPositions[poolIndex].forEach(function (value)
          {
            offset += 1000 - value;
          });

          var direction = isVertical ? 'bottom' : 'right';
          var last = isRtl ? 0 : handlesInPool - 1;
          var lastOffset = 1000 - poolPositions[poolIndex][last];

          offset = (textIsRtl && !isVertical ? 100 : 0) + (offset / handlesInPool) - lastOffset;

          // Center this tooltip over the affected handles
          tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
          tooltips[handleNumber].style.display = 'block';
          tooltips[handleNumber].style[direction] = offset + '%';
        }
      });
    });
  };

  for (let rangeSliderWidget of rangeSliderWidgets)
    window.cartzilla.createRangeSliderWidget(rangeSliderWidget);
  /* eslint-enable no-undef */
})()
